<div class="container-no-result container-2 text-center">
    <div class="category-noresults">
        <h3 class="title-l ttu mt-16">{{ 'dev.category.filters.noResults' | translate }}</h3>
    </div>
</div>
